import React, {Component} from 'react';
import {isAllowed, ROLES, withRoles} from '../Permissions';
import AssessmentTable from './AssessmentsTable';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {Tabs, Tab, AppBar, withStyles} from "@material-ui/core";
import {BASENAME} from "../../constants";
import grey from "@material-ui/core/colors/grey";
import withMobileDialog from "@material-ui/core/withMobileDialog/withMobileDialog";
import {connect} from "react-redux";
import {ACTION_TYPES, actions} from "../../actions";

const styles = theme => ({
    container:{
        display:'flex',
        justifyContent: 'space-between'
    }
})

const showTabs = (user, compRoles, component) => {
    if(isAllowed(user, compRoles)) {
        return component;
    } else {
        return <div></div>;
    }
};

class Assessments extends Component {
    constructor(props){
        super(props);
        this.state={
            selectedTab:0
        }
    }

    handleTabChange=(e,newValue)=>{
        this.setState({selectedTab:newValue})
        this.props.setNewFields({
            type:ACTION_TYPES.SET_FIELDS.SET_IS_ALL_ASSESSMENTS_VIEW,
            payload:newValue
        })
    }

    render() {
        return (
            <div>
                <Typography variant="h3" gutterBottom>
                    Assessments
                </Typography>
                <div className = {this.props.classes.container}>
                    {showTabs(
                        this.props.user,
                        [ROLES.ADMIN],
                        <Tabs value={this.props.form.adminView||0} onChange={this.handleTabChange}>
                            <Tab label="My Assessments"/>
                            <Tab label="All Assessments"/>
                        </Tabs>
                    )}
                    <div>
                        <Button href={BASENAME + "/assessments/new"} variant="contained" color="secondary" onClick={this.handleNext}>
                            New Assessment
                        </Button>
                    </div>
                </div>
                    <div>
                        {!this.props.form.adminView&&<AssessmentTable/>}
                        {this.props.form.adminView==1&&<AssessmentTable/>}
                        {/*<AssessmentTable/>*/}
                    </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        form:state.filteredAssessmentsForm
    };
}

export default connect(mapStateToProps,actions)(withRoles([ROLES.COORDINATOR,ROLES.DEPARTMENTCOORDINATOR, ROLES.ADMIN])(withStyles(styles)(Assessments)));
